module.exports = __webpack_public_path__ + "img/27_30.9deaba0f.png";